// extracted by mini-css-extract-plugin
export default {"buttonActionStyle":"buttonActionStyle--67a7677a","rejectContent":"rejectContent--555ab254"};